import { useEffect, useRef, useState } from 'react'

const useIsVisible = (ref: React.RefObject<HTMLElement>) => {
  const [isIntersecting, setIsIntersecting] = useState(true)

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        // eslint-disable-next-line no-restricted-syntax
        for (const entry of entries) {
          setIsIntersecting(entry.isIntersecting)
        }
      },
      {
        threshold: [0.1, 0.9],
      },
    )

    if (ref.current) {
      observer.observe(ref.current)
    }

    return () => observer.disconnect()
  }, [ref])

  return isIntersecting
}

export const useVisibilityChanged = (
  ref: React.RefObject<HTMLElement>,
  callback: (isVisible: boolean) => void,
) => {
  const previousIsVisible = useRef(false)
  const isVisible = useIsVisible(ref)

  useEffect(() => {
    if (isVisible !== previousIsVisible.current) {
      callback(isVisible)
      previousIsVisible.current = isVisible
    }
  }, [isVisible, callback])
}
